<template>
    <ul>
        <li v-for="option in _options" :key="option.id">
            <input type="checkbox"
                   :id="option.id"
                   :name="questionId"
                   :value="option.value"
                   :checked="option.selected"
                   @change="select(option)"
            >
            <label :for="option.id">{{ option.label }}</label>
        </li>
    </ul>
</template>

<script>
/* eslint-disable indent, no-underscore-dangle */
export default {
  data: () => ({
    // eslint-disable-next-line vue/no-reserved-keys
    _options: null,
  }),
  props: {
    questionId: String,
    options: Array,
  },
  methods: {
    select(option) {
      // eslint-disable-next-line no-param-reassign
      option.selected = !option.selected;
      this.$emit('change', this._options);
    },
  },
  watch: {
    questionId() {
      // does not fire for the first question (or last, if going back)
      this._options = this.options;
    },
  },
  created() {
    // fires only for the first question (or last, if going back)
    this._options = this.options;
  },
};
</script>

<style lang="scss">
.kws-quiz {
  input[type="checkbox"] + label::before {
    width: rem(20px);
    height: rem(20px);
    border: 2px solid $color-kws-black-15;
    background-color: #fff;
    display: block;
    content: "";
    position: absolute;
    inset-inline-start: 0;
  }

  input[type="checkbox"]:checked + label::before {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4gIDxnIGZpbGw9Im5vbmUiPiAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IiNGRjZDMDAiLz4gICAgPHBvbHlnb24gZmlsbD0iI0ZGRiIgcG9pbnRzPSI4LjY4OCAxMi44MyA0LjkzNyA5LjgyOSAzLjA2MyAxMi4xNzEgOS4zMTIgMTcuMTcgMTcuMjI5IDUuODYgMTQuNzcxIDQuMTQiLz4gIDwvZz48L3N2Zz4=);
    border: 0;
  }
}
</style>
